import fileDownload from 'js-file-download';
import axiosInstance from "../../../config/axios-config";

async function fetchAdminStudentsData(url, jwtToken, setStudentsData) {
  try {
    const response = await axiosInstance.get(url, {
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      },
    });
    
    const data = await response.data;

    await data.sort((student1, student2) => {
      const department1 = student1.department.toLowerCase();
      const department2 = student2.department.toLowerCase();

      if(department1 < department2) {
        return -1;
      }

      if(department1 > department2) {
        return 1;
      }

      const username1 = student1.username;
      const username2 = student2.username;

      return username1 - username2;
    });

    setStudentsData(data);
  } catch (err) {
    // console.error(err);
    setStudentsData([]);
  }
};

async function deleteStudentByGrNo(url, jwtToken, username, deleteStudentFromList, toast) {
  if (!window.navigator.onLine) {
    toast.error("Could not delete the student, as your system has no internet connectivity.Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });

    return;
  } 

  try {
    await axiosInstance.delete(url, {
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      },
    });

    await deleteStudentFromList(username);
    
    toast.success(`Student with GR/PR No ${username} is successfully deleted.`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      }
    );                                               
  } catch (err) {
    if(err.response && err.response.status > 400) {
      toast.error("Could not delete the user, as it is an active user.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  }
};

async function downloadStudentsDataCsv(url, jwtToken, filename, toast) {
  if (!window.navigator.onLine) {
    toast.error("Could not download the file, as your system has no internet connectivity. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });

    return;
  } 

  try {
    const response = await axiosInstance.get(url, {
      responseType: 'blob',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      },
    }); 
    
    const data = await response.data;

    await fileDownload(data, filename);

    toast.success(`Your file has been successfully downloaded.`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      }
    );
  } catch (err) {
    // console.error(err);
  }
};

async function uploadStudentsDataCsv(url, jwtToken, formData, toast) {
  if (!window.navigator.onLine) {
    toast.error("Could not upload the file, as your system has no internet connectivity. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });

    return;
  } 

  await toast.promise(axiosInstance.post(url, formData, {
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
        'content-type': 'multipart/form-data'
      }
    }),{
      pending: 'File upload is in progress.',
      success: 'File got successfully uploaded.',
      error: 'Error occured while uploading file. Please try again.'
    }
  )
};

export { fetchAdminStudentsData, downloadStudentsDataCsv, uploadStudentsDataCsv, deleteStudentByGrNo };